import type { LeagueCategory, LeagueDivision, LeagueDivisionId, LeagueLevel, LeagueRankings } from '../model/types';

/** Display order: professional divisions first, then amateur; mixed, women, men inside each level. */
export const LEAGUE_DIVISION_IDS: readonly LeagueDivisionId[] = [
  'mixed-pro',
  'women-pro',
  'men-pro',
  'mixed-amateur',
  'women-amateur',
  'men-amateur',
];

export const LEAGUE_LEVELS: readonly LeagueLevel[] = ['pro', 'amateur'];

export const parseDivisionId = (value: unknown): LeagueDivisionId | null =>
  LEAGUE_DIVISION_IDS.find((divisionId) => divisionId === value) ?? null;

/**
 * A division still taking shape: no team has a place in its table yet. Its page is noindex, and next-sitemap.config.js
 * leaves it out of the sitemap by the same rule.
 */
export const isLeagueDivisionEmpty = (division: Pick<LeagueDivision, 'teamsCount'>): boolean =>
  division.teamsCount === 0;

/** `women-pro` → `{ category: 'women', level: 'pro' }`. */
export const toLeagueDivisionParts = (id: LeagueDivisionId): Pick<LeagueDivision, 'category' | 'level'> => {
  const [category, level] = id.split('-') as [LeagueCategory, LeagueLevel];

  return { category, level };
};

export const getDivisionsByLevel = (rankings: LeagueRankings, level: LeagueLevel): LeagueDivision[] =>
  rankings.divisions
    .filter((division) => division.level === level)
    .sort((left, right) => LEAGUE_DIVISION_IDS.indexOf(left.id) - LEAGUE_DIVISION_IDS.indexOf(right.id));
